import styled from 'styled-components'
import { Paper, Grid } from '@material-ui/core'
import { StyledExternalLink, StyledH5 } from '../../../theme/Global'
import silhouetteImage from '../../../app/images/silhouette.png'

export const WidgetContainerCard = styled(Paper)`
    height: ${(props) => (props.type === 'postings' || props.type === 'minWagePaidLeave' ? '335px' : '225px')};
    padding: 24px 35px;
    box-shadow: unset;
`

export const WidgetContainer = styled.div`
    height: ${(props) => (props.type === 'postings' || props.type === 'minWagePaidLeave' ? '335px' : '225px')};
    max-width: 275px;
`

export const CustomH5 = styled(StyledH5)`
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
    text-align: left;
    padding-bottom: 0;
`

export const CustomImage = styled.div`
    border-radius: 50%;
    height: 85px;
    width: 85px;
    background:
      url('${(props) => (props.image ? props.image : silhouetteImage)}')
      no-repeat
      center center;
    background-size: cover;
`

export const StyledGrid = styled(Grid)`
 margin-top: 40px;
`

export const StyledParagraph = styled.p`
    font-size: 15px;
    font-weight: 400;
    margin-top: 25px;
`

export const StyledManagerName = styled.p`
    font-size: 15px;
    font-weight: 600;
    margin-top: 10px;
`

export const StyledSmallLink = styled(StyledExternalLink)`
    font-size: 12px;
`

export const EmailDiv = styled.div`
    display: inline-block;
    position: relative;
    top: -7px;
`
